import {
  activation,
  ACTIVATION_ACTIVE,
  CURRENT_YEAR,
  NUMBER_OF_POSSIBLE_PROJECTS,
  PERIOD_END,
  PERIOD_START,
  resetDialog,
  setPeriod,
  STEP,
  validateActivation
} from "../../../ducks/templateActivation";

import { SELECTED_PROGRAM, SELECTED_PROGRAM_INSTANCE } from "../../../ducks/fundingArea";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TemplateActivation from "./TemplateActivation";

const mapStateToProps = (state, ownProps) => {
  return {
    show: ownProps.show,
    template: ownProps.template,
    [PERIOD_START]: state.templateActivation[PERIOD_START],
    [PERIOD_END]: state.templateActivation[PERIOD_END],
    [STEP]: state.templateActivation[STEP],
    [NUMBER_OF_POSSIBLE_PROJECTS]: state.templateActivation[NUMBER_OF_POSSIBLE_PROJECTS],
    [CURRENT_YEAR]: state.templateActivation[CURRENT_YEAR],
    [ACTIVATION_ACTIVE]: state.templateActivation[ACTIVATION_ACTIVE],
    [SELECTED_PROGRAM]: state.fundingArea[SELECTED_PROGRAM]?.templateActivation,
    [SELECTED_PROGRAM_INSTANCE]: state.fundingArea[SELECTED_PROGRAM_INSTANCE]?.templateActivation,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    actions: bindActionCreators(
      {
        setPeriod,
        validateActivation,
        activation,
        resetDialog
      },
      dispatch
    ),
    externalActions: {
      close: ownProps.close
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateActivation);
